// import React, { useState, useEffect } from 'react';
// import { FaTimes, FaTrain, FaExclamationCircle, FaCheckCircle } from 'react-icons/fa';

// const TrainModal = ({ isOpen, onClose, onAdd, editingItem }) => {
//   const [formData, setFormData] = useState({
//     name: '',
//     trainNumber: '',
//     operator: '',
//     departure: '',
//     arrival: '',
//     departureTime: '',
//     arrivalTime: '',
//     class: 'Second Class',
//     price: ''
//   });

//   const [errors, setErrors] = useState({});
//   const [isSubmitting, setIsSubmitting] = useState(false);

//   const pad = (num) => String(num).padStart(2, '0');
//   const formatDateTimeLocal = (date) => {
//     const d = new Date(date);
//     return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
//   };

//   useEffect(() => {
//     if (editingItem) {
//       setFormData(editingItem);
//     } else {
//       const now = new Date();
//       const defaultDeparture = new Date(now.getTime() + 2 * 60 * 60 * 1000);
//       const defaultArrival = new Date(now.getTime() + 4 * 60 * 60 * 1000);
//       setFormData({
//         name: '',
//         trainNumber: '',
//         operator: '',
//         departure: '',
//         arrival: '',
//         departureTime: formatDateTimeLocal(defaultDeparture),
//         arrivalTime: formatDateTimeLocal(defaultArrival),
//         class: 'Second Class',
//         price: ''
//       });
//     }
//     setErrors({});
//   }, [editingItem, isOpen]);

//   const validateForm = () => {
//     const newErrors = {};
    
//     if (!formData.name.trim()) newErrors.name = 'Service name is required';
//     if (!formData.trainNumber.trim()) newErrors.trainNumber = 'Train number is required';
//     if (!formData.operator.trim()) newErrors.operator = 'Operator is required';
//     if (!formData.departure.trim()) newErrors.departure = 'Departure station is required';
//     if (!formData.arrival.trim()) newErrors.arrival = 'Arrival station is required';
//     if (!formData.departureTime) newErrors.departureTime = 'Departure time is required';
//     if (!formData.arrivalTime) newErrors.arrivalTime = 'Arrival time is required';
//     if (!formData.price.trim()) newErrors.price = 'Price is required';
    
//     // Validate departure time is before arrival time
//     if (formData.departureTime && formData.arrivalTime) {
//       const depTime = new Date(formData.departureTime);
//       const arrTime = new Date(formData.arrivalTime);
//       if (depTime >= arrTime) {
//         newErrors.arrivalTime = 'Arrival time must be after departure time';
//       }
//     }
    
//     // Validate price format
//     if (formData.price && !/^\$?\d+(\.\d{2})?$/.test(formData.price)) {
//       newErrors.price = 'Please enter a valid price (e.g., $89 or 89)';
//     }
    
//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
    
//     if (!validateForm()) {
//       return;
//     }
    
//     setIsSubmitting(true);
    
//     try {
//       // Simulate API call delay
//       await new Promise(resolve => setTimeout(resolve, 500));
      
//       onAdd(formData);
//       onClose();
//     } catch (error) {
//       console.error('Error submitting train:', error);
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   const handleInputChange = (field, value) => {
//     setFormData(prev => ({ ...prev, [field]: value }));
//     // Clear error when user starts typing
//     if (errors[field]) {
//       setErrors(prev => ({ ...prev, [field]: '' }));
//     }
//   };

//   if (!isOpen) return null;

//   return (
//     <div className="fixed inset-0 !m-0 z-50 flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-md p-4 animate-fadeIn">
//       <div className="bg-white rounded-2xl shadow-2xl max-w-5xl w-full max-h-[90vh] flex flex-col transform transition-all duration-300 scale-100">
//         {/* Enhanced Header */}
//         <div className="bg-gradient-to-r from-purple-600 via-violet-700 to-indigo-700 p-8 rounded-t-2xl relative overflow-hidden">
//           <div className="absolute inset-0 bg-black bg-opacity-10"></div>
//           <div className="relative flex items-center justify-between">
//             <div className="flex items-center space-x-4">
//               <div className="bg-white bg-opacity-20 p-3 rounded-xl backdrop-blur-sm border border-white border-opacity-30">
//                 <FaTrain className="h-7 w-7 text-white" />
//               </div>
//               <div>
//                 <h3 className="text-2xl font-display font-bold text-white">
//                   {editingItem ? 'Edit Train Service' : 'Add New Train Service'}
//                 </h3>
//                 <p className="text-purple-100 text-lg">Complete train service details</p>
//               </div>
//             </div>
//             <button
//               onClick={onClose}
//               className="text-white hover:bg-white hover:bg-opacity-20 p-3 rounded-xl transition-all duration-200 hover:scale-105"
//             >
//               <FaTimes className="h-6 w-6" />
//             </button>
//           </div>
//         </div>

//         <div className="flex-1 overflow-y-auto bg-gray-50">
//           <form id="train-form" onSubmit={handleSubmit} className="p-8 space-y-8">
            

//             {/* Route Information Section */}
//             <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100">
//               <h4 className="text-lg font-semibold text-gray-900 mb-6 flex items-center">
//                 <div className="w-2 h-2 bg-blue-500 rounded-full mr-3"></div>
//                 Route Information
//               </h4>
//               <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//                 <div>
//                   <label className="block text-sm font-semibold text-gray-700 mb-3">
//                     Departure Station *
//                   </label>
//                   <div className="relative">
//                     <input
//                       type="text"
//                       value={formData.departure}
//                       onChange={(e) => handleInputChange('departure', e.target.value)}
//                       className={`w-full px-4 py-3 border rounded-xl focus:ring-2 focus:ring-purple-500 focus:border-purple-500 outline-none transition-all duration-200 ${
//                         errors.departure ? 'border-red-300 bg-red-50' : 'border-gray-300 hover:border-gray-400'
//                       }`}
//                       placeholder="e.g., New York Penn Station"
//                     />
//                     {errors.departure && (
//                       <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
//                         <FaExclamationCircle className="h-5 w-5 text-red-500" />
//                       </div>
//                     )}
//                   </div>
//                   {errors.departure && (
//                     <p className="mt-2 text-sm text-red-600 flex items-center">
//                       <FaExclamationCircle className="h-4 w-4 mr-1" />
//                       {errors.departure}
//                     </p>
//                   )}
//                 </div>

//                 <div>
//                   <label className="block text-sm font-semibold text-gray-700 mb-3">
//                     Arrival Station *
//                   </label>
//                   <div className="relative">
//                     <input
//                       type="text"
//                       value={formData.arrival}
//                       onChange={(e) => handleInputChange('arrival', e.target.value)}
//                       className={`w-full px-4 py-3 border rounded-xl focus:ring-2 focus:ring-purple-500 focus:border-purple-500 outline-none transition-all duration-200 ${
//                         errors.arrival ? 'border-red-300 bg-red-50' : 'border-gray-300 hover:border-gray-400'
//                       }`}
//                       placeholder="e.g., Washington Union Station"
//                     />
//                     {errors.arrival && (
//                       <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
//                         <FaExclamationCircle className="h-5 w-5 text-red-500" />
//                       </div>
//                     )}
//                   </div>
//                   {errors.arrival && (
//                     <p className="mt-2 text-sm text-red-600 flex items-center">
//                       <FaExclamationCircle className="h-4 w-4 mr-1" />
//                       {errors.arrival}
//                     </p>
//                   )}
//                 </div>

//                 <div>
//                   <label className="block text-sm font-semibold text-gray-700 mb-3">
//                     Departure Time *
//                   </label>
//                   <div className="relative">
//                     <input
//                       type="datetime-local"
//                       value={formData.departureTime}
//                       onChange={(e) => handleInputChange('departureTime', e.target.value)}
//                       className={`w-full px-4 py-3 border rounded-xl focus:ring-2 focus:ring-purple-500 focus:border-purple-500 outline-none transition-all duration-200 ${
//                         errors.departureTime ? 'border-red-300 bg-red-50' : 'border-gray-300 hover:border-gray-400'
//                       }`}
//                     />
//                     {errors.departureTime && (
//                       <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
//                         <FaExclamationCircle className="h-5 w-5 text-red-500" />
//                       </div>
//                     )}
//                   </div>
//                   {errors.departureTime && (
//                     <p className="mt-2 text-sm text-red-600 flex items-center">
//                       <FaExclamationCircle className="h-4 w-4 mr-1" />
//                       {errors.departureTime}
//                     </p>
//                   )}
//                 </div>

//                 <div>
//                   <label className="block text-sm font-semibold text-gray-700 mb-3">
//                     Arrival Time *
//                   </label>
//                   <div className="relative">
//                     <input
//                       type="datetime-local"
//                       value={formData.arrivalTime}
//                       onChange={(e) => handleInputChange('arrivalTime', e.target.value)}
//                       className={`w-full px-4 py-3 border rounded-xl focus:ring-2 focus:ring-purple-500 focus:border-purple-500 outline-none transition-all duration-200 ${
//                         errors.arrivalTime ? 'border-red-300 bg-red-50' : 'border-gray-300 hover:border-gray-400'
//                       }`}
//                     />
//                     {errors.arrivalTime && (
//                       <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
//                         <FaExclamationCircle className="h-5 w-5 text-red-500" />
//                       </div>
//                     )}
//                   </div>
//                   {errors.arrivalTime && (
//                     <p className="mt-2 text-sm text-red-600 flex items-center">
//                       <FaExclamationCircle className="h-4 w-4 mr-1" />
//                       {errors.arrivalTime}
//                     </p>
//                   )}
//                 </div>
//               </div>
//             </div>

            
//           </form>
//         </div>
//         {/* Enhanced Footer */}
//         <div className="flex-shrink-0 bg-white border-t border-gray-200 p-8">
//           <div className="flex flex-col sm:flex-row gap-4">
//             <button
//               type="submit"
//               form="train-form"
//               disabled={isSubmitting}
//               className="flex-1 bg-gradient-to-r from-purple-600 via-violet-700 to-indigo-700 text-white py-4 px-8 rounded-xl font-semibold text-lg hover:from-purple-700 hover:via-violet-800 hover:to-indigo-800 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none disabled:shadow-lg flex items-center justify-center space-x-2"
//             >
//               {isSubmitting ? (
//                 <>
//                   <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
//                   <span>Processing...</span>
//                 </>
//               ) : (
//                 <>
//                   <FaCheckCircle className="h-5 w-5" />
//                   <span>{editingItem ? 'Update Train Service' : 'Add Train to Booking'}</span>
//                 </>
//               )}
//             </button>
//             <button
//               onClick={onClose}
//               disabled={isSubmitting}
//               className="flex-1 bg-gray-100 text-gray-700 py-4 px-8 rounded-xl font-semibold text-lg hover:bg-gray-200 transition-all duration-300 border border-gray-300 hover:border-gray-400 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center space-x-2"
//             >
//               <FaTimes className="h-5 w-5" />
//               <span>Cancel</span>
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default TrainModal;

import React, { useState, useEffect } from "react";
import {
  FaTimes,
  FaTrain,
  FaExclamationCircle,
  FaCheckCircle,
} from "react-icons/fa";

const dummyTrains = [
  { id: 1, name: "Rajdhani Express", price: "₹1200" },
  { id: 2, name: "Shatabdi Express", price: "₹950" },
  { id: 3, name: "Duronto Express", price: "₹1500" },
  { id: 4, name: "Garib Rath", price: "₹700" },
];

const pad = (num) => String(num).padStart(2, "0");
const formatDateTimeLocal = (date) => {
  const d = new Date(date);
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(
    d.getHours()
  )}:${pad(d.getMinutes())}`;
};

const TrainModal = ({ isOpen, onClose, onAdd, editingItem }) => {
  const [formData, setFormData] = useState({
    departure: "",
    arrival: "",
    departureTime: "",
    arrivalTime: "",
  });
  const [errors, setErrors] = useState({});
  const [showResults, setShowResults] = useState(false);

  useEffect(() => {
    if (editingItem) {
      setFormData(editingItem);
    } else {
      const now = new Date();
      const defaultDeparture = new Date(now.getTime() + 2 * 60 * 60 * 1000);
      const defaultArrival = new Date(now.getTime() + 4 * 60 * 60 * 1000);

      setFormData({
        departure: "",
        arrival: "",
        departureTime: formatDateTimeLocal(defaultDeparture),
        arrivalTime: formatDateTimeLocal(defaultArrival),
      });
    }
    setErrors({});
    setShowResults(false);
  }, [editingItem, isOpen]);

  const validateForm = () => {
    const newErrors = {};
    if (!formData.departure.trim())
      newErrors.departure = "Departure station is required";
    if (!formData.arrival.trim())
      newErrors.arrival = "Arrival station is required";
    if (!formData.departureTime)
      newErrors.departureTime = "Departure time is required";
    if (!formData.arrivalTime)
      newErrors.arrivalTime = "Arrival time is required";

    if (formData.departureTime && formData.arrivalTime) {
      const dep = new Date(formData.departureTime);
      const arr = new Date(formData.arrivalTime);
      if (dep >= arr) {
        newErrors.arrivalTime = "Arrival must be after departure";
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSearch = (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    setShowResults(true);
  };

  const handleSelectTrain = (train) => {
    const selectedTrain = {
      ...formData,
      name: train.name,
      price: train.price,
    };
    onAdd(selectedTrain);
    onClose();
  };

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    if (errors[field]) {
      setErrors((prev) => ({ ...prev, [field]: "" }));
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 !m-0 z-50 flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-md p-4 animate-fadeIn">
      <div className="bg-white rounded-2xl shadow-2xl max-w-5xl w-full max-h-[90vh] flex flex-col">
        {/* Header */}
        <div className="bg-gradient-to-r from-purple-600 via-violet-700 to-indigo-700 p-8 rounded-t-2xl flex justify-between items-center">
          <div className="flex items-center space-x-3">
            <FaTrain className="text-white text-2xl" />
            <h3 className="text-xl font-bold text-white">
              {editingItem ? "Edit Train Service" : "Add Train Service"}
            </h3>
          </div>
          <button
            onClick={onClose}
            className="text-white hover:bg-white hover:bg-opacity-20 p-2 rounded-xl"
          >
            <FaTimes className="h-5 w-5" />
          </button>
        </div>

        {/* Body */}
        <div className="flex-1 overflow-y-auto bg-gray-50 p-8">
          {!showResults ? (
            <form onSubmit={handleSearch} className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Departure */}
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Departure Station *
                  </label>
                  <input
                    type="text"
                    value={formData.departure}
                    onChange={(e) =>
                      handleInputChange("departure", e.target.value)
                    }
                    className={`w-full px-4 py-3 border rounded-xl ${
                      errors.departure
                        ? "border-red-300 bg-red-50"
                        : "border-gray-300"
                    }`}
                    placeholder="e.g., Mumbai Central"
                  />
                  {errors.departure && (
                    <p className="text-sm text-red-600 mt-1">
                      {errors.departure}
                    </p>
                  )}
                </div>

                {/* Arrival */}
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Arrival Station *
                  </label>
                  <input
                    type="text"
                    value={formData.arrival}
                    onChange={(e) => handleInputChange("arrival", e.target.value)}
                    className={`w-full px-4 py-3 border rounded-xl ${
                      errors.arrival
                        ? "border-red-300 bg-red-50"
                        : "border-gray-300"
                    }`}
                    placeholder="e.g., Delhi Junction"
                  />
                  {errors.arrival && (
                    <p className="text-sm text-red-600 mt-1">
                      {errors.arrival}
                    </p>
                  )}
                </div>

                {/* Departure Time */}
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Departure Time *
                  </label>
                  <input
                    type="datetime-local"
                    value={formData.departureTime}
                    onChange={(e) =>
                      handleInputChange("departureTime", e.target.value)
                    }
                    className={`w-full px-4 py-3 border rounded-xl ${
                      errors.departureTime
                        ? "border-red-300 bg-red-50"
                        : "border-gray-300"
                    }`}
                  />
                  {errors.departureTime && (
                    <p className="text-sm text-red-600 mt-1">
                      {errors.departureTime}
                    </p>
                  )}
                </div>

                {/* Arrival Time */}
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Arrival Time *
                  </label>
                  <input
                    type="datetime-local"
                    value={formData.arrivalTime}
                    onChange={(e) =>
                      handleInputChange("arrivalTime", e.target.value)
                    }
                    className={`w-full px-4 py-3 border rounded-xl ${
                      errors.arrivalTime
                        ? "border-red-300 bg-red-50"
                        : "border-gray-300"
                    }`}
                  />
                  {errors.arrivalTime && (
                    <p className="text-sm text-red-600 mt-1">
                      {errors.arrivalTime}
                    </p>
                  )}
                </div>
              </div>

              <div className="flex justify-end">
                <button
                  type="submit"
                  className="bg-purple-600 text-white px-6 py-3 rounded-xl font-semibold hover:bg-purple-700 transition"
                >
                  Search Trains
                </button>
              </div>
            </form>
          ) : (
            <div>
              <h4 className="text-lg font-semibold mb-4">Available Trains 🚆</h4>
              <div className="space-y-4">
                {dummyTrains.map((train) => (
                  <div
                    key={train.id}
                    className="flex justify-between items-center bg-white p-4 rounded-xl shadow"
                  >
                    <div>
                      <p className="font-semibold text-gray-800">
                        {train.name}
                      </p>
                      <p className="text-gray-500">{train.price}</p>
                    </div>
                    <button
                      onClick={() => handleSelectTrain(train)}
                      className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 transition"
                    >
                      Select
                    </button>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="bg-white border-t p-4 flex justify-end">
          <button
            onClick={onClose}
            className="bg-gray-100 px-6 py-2 rounded-lg hover:bg-gray-200"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default TrainModal;
